import { InjectionToken } from "@angular/core";

import { ExportOption } from "@logex/framework/lg-charts";

export const CHART_EXPORT_FORMATS = new InjectionToken<ExportOption[]>("ChartExportOptions");
